import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var Row = function Row(props) {
  var rowClass = classNames({
    row: true,
    around: props.around,
    between: props.between,
    start: props.start,
    center: props.center,
    end: props.end,
    top: props.top,
    middle: props.middle,
    bottom: props.bottom,
    reverse: props.reverse
  }, props.className);
  return React.createElement("div", {
    className: rowClass
  }, props.children);
};

Row.propTypes = {
  className: PropTypes.string
};
Row.defaultProps = {
  className: ''
};
Row.displayName = 'Row';
export default React.memo(Row);